<app-header-mobile *ngIf="isMobile"></app-header-mobile>
<app-header *ngIf="!isMobile"></app-header>
<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->
<button *ngIf="showInstallButton && isMobile" (click)="installPWA()" class="btn btn-primary">

  {{ "Add to Home Screen" | translate }}
</button>